import { createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { BASE_HTTPS_URL } from "../../utils/constants";

export interface ICreateRoomQuery {
  admin_name: string;
  game_type: "music_mafia";
}

export interface ICreateRoomResponse {
  room_id: string;
  admin_id: string;
}

export const createRoom = createAsyncThunk(
  'main/createRoom',
  async (query: ICreateRoomQuery) => {
    try {
      const response = await axios.post(`${BASE_HTTPS_URL}rooms`, query);
      return response.data as ICreateRoomResponse;
    } catch (error) {
      console.error(error);
      return Promise.reject();
    }
  },
)

export interface IJoinRoomQuery {
  room_id: string;
  user_name: string;
}

export interface IJoinRoomResponse {
  user_id: string;
}

export const joinRoom = createAsyncThunk(
  'main/joinRoom',
  async (arg: IJoinRoomQuery) => {
    try {
      const response = await axios.post(`${BASE_HTTPS_URL}rooms/${arg.room_id}`, {user_name: arg.user_name});
      return {...response.data, room_id: arg.room_id} as IJoinRoomResponse & {room_id: string};
    } catch (error) {
      console.error(error);
      return Promise.reject();
    }
  },
)